/* unplugin-vue-components disabled */import { render } from "./snackbarComponent.vue?vue&type=template&id=0320e3a5&scoped=true"
import script from "./snackbarComponent.vue?vue&type=script&lang=js"
export * from "./snackbarComponent.vue?vue&type=script&lang=js"

import "./snackbarComponent.vue?vue&type=style&index=0&id=0320e3a5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0320e3a5"]])

export default __exports__